import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { IncidentLogCountBySeverityViewModel, IncidentLogWidgetBar } from "./IncidentLogWidget.types.ts";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "@localization/useTranslation";
import { SeverityLevelEnum } from "../../incidentLog/IncidentLogDialog.types.ts";
import { setFirstLetterToLowerCase } from "@common/stringOperations";
import { useUrlProvider } from "../../useUrlProvider.ts";
import { NavigationMenuItem } from "../../navigationMenuSettings/NavigationMenuSettings.types";
import { isNavigationMenuItemHidden } from "../../navigationMenuSettings/navigationMenuItems";

export function UseIncidentLogWidget() {
    const userContext = useUserContext();
    const { translateString } = useTranslation();
    const { getIncidentLogUrl } = useUrlProvider();
    const isEnabled =
        userContext.permissions.incidentLogPermissions.read &&
        !isNavigationMenuItemHidden(userContext.hiddenNavigationMenuItems, NavigationMenuItem.IncidentLog);

    const url = `/incidentLog/dashboard/bySeverity`;
    const { isLoading, data } = useDotLegalQuery<Array<IncidentLogCountBySeverityViewModel>>(url, {
        enabled: isEnabled,
    });

    let highestNumberOfIncidents = 0;
    if (data) {
        const numberOfIncidents = data!.map((x) => x.numberOfIncidents);
        highestNumberOfIncidents = Math.max(...numberOfIncidents);
    }

    function getSeverityName(severity: SeverityLevelEnum) {
        return translateString(setFirstLetterToLowerCase(SeverityLevelEnum[severity].toString()));
    }

    const graphData: Array<IncidentLogWidgetBar> = (data ?? []).map((x) => ({
        severityName: getSeverityName(x.severity),
        numberOfIncidents: x.numberOfIncidents,
        url: getIncidentLogUrl({ severity: x.severity }),
    }));

    return {
        isLoading,
        data: graphData,
        isEnabled,
        highestNumberOfIncidents,
    };
}
